export const PACKAGE = {
  LIST: "/package",
  CREATE: "/package",
  CREATE_USER_PACKAGE: `/user-package/`,
  UPDATE: (id: string) => `/package/${id}`,
  DELETE: (id: string) => `/package/${id}`,
  DETAIL: (id: string) => `/package/${id}`,
  PACKAGE_BY_CODE: (code: string) => `/package/code/${code}`,
  PACKAGE_BY_USER_ID: `/user-package/by-user/`,
  UPDATE_USER_PACKAGE: (userPkgId: string) => `/user-package/${userPkgId}`,
  DELETE_USER_PACKAGE: (userPackageId: string) =>
    `/user-package/${userPackageId}`,
};
